import {Injectable} from "@angular/core";
import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {environment} from "@environments/environment";
import {catchError, Observable, throwError} from "rxjs"; 
import {Token,Login, ValidateResponse, ApiResponse, ValidateCode}  from "@core/types";

@Injectable({
  providedIn: 'root',
})

export  class AuthService{
  baseUrl: string;


  constructor(private httpClient: HttpClient,) {
    this.baseUrl =  environment.api + '/auth';
  }

  login(item: Login): Observable<ApiResponse<Token>> {
    return this.httpClient.post<ApiResponse<Token>>(this.baseUrl, item)
      .pipe(  catchError((errorReponse: HttpErrorResponse) => {
        // #region agent log H3
        fetch('http://127.0.0.1:7242/ingest/09ffa633-5112-4ad9-a766-b5dccdf15471',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({sessionId:'debug-session',runId:'pre',hypothesisId:'H3',location:'auth.service.ts:login_catchError',message:'AuthService.login caught HTTP error',data:{status:errorReponse?.status,url:errorReponse?.url,errorType:typeof errorReponse?.error,hasErrorMessage:!!(errorReponse as any)?.error?.message},timestamp:Date.now()})}).catch(()=>{});
        // #endregion
        return throwError(()=>`${errorReponse.error.message}` );
      }));
  }

  changePassword(item: any): Observable<ApiResponse<string>> {
    return this.httpClient.patch<ApiResponse<string>>(this.baseUrl + '/changePassword', item)
      .pipe(  catchError((errorReponse: HttpErrorResponse) => {
        return throwError(()=>`${errorReponse.error.message}` );
      }));
  }
  
  resendCode(regHash: string): Observable<ApiResponse<string>> {
    return this.httpClient.post<ApiResponse<string>>(this.baseUrl + '/ReSendValidationCode', {hash: regHash})
      .pipe(  catchError((errorReponse: HttpErrorResponse) => {
        return throwError(()=>`${errorReponse.error.message}` );
      }));
  }

  validateCode(validateCode: ValidateCode): Observable<ApiResponse<ValidateResponse>> {
    return this.httpClient.post<ApiResponse<ValidateResponse>>(this.baseUrl + '/ValidateCode', validateCode)
      .pipe(  catchError((errorReponse: HttpErrorResponse) => {
        return throwError(()=>`${errorReponse.error.message}` );
      }));
  }

  refreshToken(refreshToken: string): Observable<ApiResponse<Token>> {
    return this.httpClient.post<ApiResponse<Token>>(this.baseUrl + '/refresh', { refreshToken })
      .pipe(  catchError((errorReponse: HttpErrorResponse) => {
        return throwError(()=>`${errorReponse.error.message}` );
      }));
  }



}
